import React from 'react';
import { Image } from '@mantine/core';
import { Container, imageStyle } from './styles';

interface GoalCardImageViewProps {
  imageURL: string;
}

export const GoalCardImageView: React.FC<GoalCardImageViewProps> = ({
  imageURL,
}) => {
  const url = `${process.env.REACT_APP_CARD_IMAGEBUCKET_URL}/${imageURL}`;
  return (
    <Container>
      <Image
        src={url}
        withPlaceholder
        style={imageStyle}
        radius={imageStyle.radius}
      />
    </Container>
  );
};
